/**
 * Directiva utilizada para ver y añadir inspecciones a las incidencias
 */
CamposExtraDetallesDirectiva.$inject = ['lang'];

export default function CamposExtraDetallesDirectiva(lang) {
    return {
        restrict: 'AE',
        scope: {
            'modelId': '=',
            'onlyRequired': '@',
            'tagId': '@'
        },
        template: require('./campos-extra-detalles.html'),
        controller: 'CamposExtraDetallesCtrl as campExtDet',
        bindToController: true
    }
}